import createAxiosFn from './request';
// getToken ()是用来获取当前项目中的token的
// import { getToken } from '../util/utils';
import { message } from 'antd';
export function apiGet(url:any, data:any,a:any,b:any) {
  return new Promise((resolve, reject) => {
    return createAxiosFn(a,a,b)
      .get(url, data)
      .then((res:any) => {
        if (res.status === 200 || res.status === 0) {
          resolve(res.data);
        } else {
          reject(res);
          message.error(res);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function apiPost(url:any, data:any,a:any,b:any) {
  return new Promise((resolve, reject) => {
    return createAxiosFn(a,a,b)
      .post(url, data)
      .then((res:any) => {
        if (res.status === 200 || res.status === 0) {
          resolve(res.data);
        } else {
          reject(res);
          message.error(res);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}